import React, { useState } from 'react';
import { FaUser, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { FiSend } from 'react-icons/fi';
import {
  Contact1,
  MaxWidth,
  Title,
  Heading,
  Content,
  ColumnLeft,
  ColumnRight,
  Text,
  P,
  Icons,
  Row,
  IconBox,
  Info,
  Head,
  SubTitle,
  Form,
  FieldRow,
  Field,
  Label,
  Input,
  TextArea,
  Button,
  Status,
  Spinner,
} from './Contact.elements';

const reveal = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: 0.1 * i, ease: 'easeOut' },
  }),
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const initial = { name: '', email: '', subject: '', message: '' };

function Contact() {
  const [form, setForm] = useState(initial);
  const [state, setState] = useState('idle'); // idle | loading | ok | error
  const [msg, setMsg] = useState('');

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.message.trim()) {
      setState('error');
      setMsg('Please fill in your name and message.');
      return;
    }
    if (!EMAIL_RE.test(form.email)) {
      setState('error');
      setMsg('Please enter a valid email address.');
      return;
    }

    setState('loading');
    setMsg('');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setState('ok');
        setMsg('Thanks! Your message has been sent — I’ll get back to you soon.');
        setForm(initial);
      } else {
        setState('error');
        setMsg(data.error || 'Could not send your message. Please try again.');
      }
    } catch (err) {
      setState('error');
      setMsg('Network error. Please try again later.');
    }
  };

  return (
    <Contact1 id="contact">
      <MaxWidth>
        <Title variants={reveal} initial="hidden" animate="visible">
          Get in touch
        </Title>
        <Heading variants={reveal} custom={1} initial="hidden" animate="visible">
          Contact me
        </Heading>

        <Content>
          <ColumnLeft>
            <Text>Let’s build something together</Text>
            <P>
              Reach out for collaborations, freelance work, or just to say hi.
              I usually respond within a day.
            </P>
            <Icons>
              <Row>
                <IconBox>
                  <FaUser />
                </IconBox>
                <Info>
                  <Head>Name</Head>
                  <SubTitle>Enes Güngör</SubTitle>
                </Info>
              </Row>
              <Row>
                <IconBox>
                  <FaMapMarkerAlt />
                </IconBox>
                <Info>
                  <Head>Location</Head>
                  <SubTitle>Tilburg, NL · Istanbul, TR</SubTitle>
                </Info>
              </Row>
              <Row>
                <IconBox>
                  <FaEnvelope />
                </IconBox>
                <Info>
                  <Head>Email</Head>
                  <SubTitle>enesgungor.gs@gmail.com</SubTitle>
                </Info>
              </Row>
            </Icons>
          </ColumnLeft>

          <ColumnRight>
            <Form onSubmit={handleSubmit} noValidate>
              <FieldRow>
                <Field>
                  <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your name"
                    value={form.name}
                    onChange={onChange}
                  />
                </Field>
                <Field>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={onChange}
                  />
                </Field>
              </FieldRow>
              <Field>
                <Label htmlFor="subject">Subject</Label>
                <Input
                  id="subject"
                  name="subject"
                  type="text"
                  placeholder="What’s this about?"
                  value={form.subject}
                  onChange={onChange}
                />
              </Field>
              <Field>
                <Label htmlFor="message">Message</Label>
                <TextArea
                  id="message"
                  name="message"
                  placeholder="Tell me a bit about it..."
                  value={form.message}
                  onChange={onChange}
                />
              </Field>

              {state === 'ok' && <Status $ok>{msg}</Status>}
              {state === 'error' && <Status>{msg}</Status>}

              <Button type="submit" disabled={state === 'loading'}>
                {state === 'loading' ? (
                  <>
                    <Spinner /> Sending...
                  </>
                ) : (
                  <>
                    Send message <FiSend />
                  </>
                )}
              </Button>
            </Form>
          </ColumnRight>
        </Content>
      </MaxWidth>
    </Contact1>
  );
}

export default Contact;
